import { DisplayStatus } from "src/app/employee/projects/project-filters/models/filters.models";

export class SetSelectedFilters {
    static readonly type = "[Projects] Set selected project filters";

    constructor(public payload: Array<DisplayStatus>) {}
}
